import { useNavigate } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton } from "@mui/material";
import { formatNumber } from "utility/formatters";

import { TilleyCard } from "../../../Cards/TilleyCard";
import { CropIcon, DeleteIcon } from "../../../Icons/Icons";

export default function CropProfileCard({ cropProfile, onChange }) {
  const navigate = useNavigate();

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...cropProfile };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        data-testid={`Open-Crop-${cropProfile?.commodity_name}-${cropProfile?.type_name}`}
        onClick={() => navigate(`./${cropProfile?.id}`)}
        Avatar={CropIcon}
        title={
          cropProfile?.commodity_name +
          " " +
          (cropProfile?.type_name &&
            (cropProfile?.type_name !== "No Type Specified" ? " \u2013 " + cropProfile?.type_name : ""))
        }
        subtitle={cropProfile?.practice_name}
        action={
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteOnClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
        details={[
          {
            value: formatNumber(cropProfile?.reported_acreage, 0),
            label: "ACRES",
          },
          {
            value: formatNumber(cropProfile?.approved_yield, 0),
            label: "APH",
          },
        ]}
      />
      {confirmDialogComponent}
    </>
  );
}
